Storage = require('resources/assets/coffee/Core/Storage').Storage

class exports.OverlayStorage extends Storage

    constructor: () ->
        super()

        @feature_group = new L.FeatureGroup()


    delete: (k) ->
        v = @retrieve(k)

        if v?
            @key_count = @key_count - 1

            if v instanceof OverlayStorage
                v = v.feature_group

            @feature_group.removeLayer v
            App.map.removeLayer v

            delete @data[k]


    store: (k, v) ->
        super(k, v)

        if v instanceof OverlayStorage
            @feature_group.addLayer v.feature_group
        else
            @feature_group.addLayer v
            v.addTo App.map


    # Shortcut for getting the bounds of the feature group
    getBounds: () ->
        if @count() > 0
            return @feature_group.getBounds()
        else
            return App.map.getBounds()


    # Shortcut for loading and displaying a field boundary
    loadField: (fields_id, displayOpts = {}, fitBounds = true) ->
        def_style = {
            fillColor: '#00FF00',
            color: '#00FF00',
            opacity: 0.75
            weight: 2
            fillOpacity: 0.2
        }

        style = $.extend def_style, displayOpts

        $.post 'backend/grower/fields/get-boundary',
            id: fields_id,
            (result) =>

                # Load the layer's geojson into a
                # L.FeatureGroup, and add it to
                # our existing group of fields
                gj = L.geoJson result.data?.boundary,
                    style: () ->
                        return style

                fg = new L.FeatureGroup()
                L.GeoUtil.unnestAdd(fg, gj)

                @store fields_id, fg

                if fitBounds

                    # Fit all field boundaries on the map view, with
                    # specific zoom levels for locales that need them
                    switch result.data?.locale
                        when 'en_CA'
                            App.map.fitBounds(@getBounds(), { maxZoom: 16 })
                        when 'en_ZA'
                            App.map.fitBounds(@getBounds(), { maxZoom: 17 })
                        else
                            App.map.fitBounds @getBounds()

                # add the boundary to the map
                fg.addTo App.map
